import { request, getHost } from './utils';

// 更新獵場提問的回答.
export const putQAReply = ({ token, id, reply }) => {
  const options = {
    method: 'put',

    url: `${getHost()}/api/v1/qa/${id}/reply`,

    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Authorization: `Bearer ${token}`
    },

    data: {
      reply
    }
  };

  return request(options);
};
